import {Pipe, PipeTransform} from '@angular/core';
import * as _ from 'lodash';

@Pipe({
    name: 'uniqBy',
    standalone: false
})
export class UniqByPipe implements PipeTransform {
  transform(value: any[], propName): any[] {
    return _.uniqBy(value, propName);
  }
}
